import { render, staticRenderFns } from "./FaqsViewChart.vue?vue&type=template&id=7056f9f6"
import script from "./FaqsViewChart.vue?vue&type=script&lang=js"
export * from "./FaqsViewChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports